/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rounds_Find_PlaceholderInputs */



/**
* | output |
* | --- |
* | "Name or VEKN ID…" |
*
* @param {Rounds_Find_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const rounds_find_placeholder = /** @type {((inputs?: Rounds_Find_PlaceholderInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rounds_Find_PlaceholderInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Nom ou VEKN ID…")
	if (locale === "es") return /** @type {LocalizedString} */ ("Nombre o ID VEKN…")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Nome ou VEKN ID…")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nome o VEKN ID…")
	return /** @type {LocalizedString} */ ("Name or VEKN ID…")
});